import React from 'react'
import styles from './AdvtFullSize.module.css'
import { useGetParams } from '../../hooks/useGetParams'
import classNames from 'classnames'
import { motion } from 'framer-motion'
import logo from '../../assets/images/logo.png'

const AdvtFullSize = React.memo(({ className, currentState, advtInfo }) => {
  const { paddingQR, sizeQR, titleFontSize } = useGetParams()

  const { label, qrCode1, qrCode2 } = advtInfo

  return (
    <motion.div
      key="advt"
      style={{ width: '100%' }}
      initial={{ opacity: 0, flex: 1 }}
      animate={{ opacity: 1, flex: 1 }}
      transition={{ duration: 1, delay: 1 }}
      className={classNames(styles.container, className)}
    >
      <div className={styles.logoContainer}>
        <img src={logo} alt="logo" />
      </div>
      <motion.div key="title" className={classNames(styles.title)}>
        <h1 style={{ fontSize: `${titleFontSize}rem` }}>{label}</h1>
      </motion.div>
      <div className={classNames(styles.qrCodes)}>
        {qrCode1 && (
          <motion.div
            key={currentState + 'qr1'}
            className={classNames(styles.rainbow, styles.rainbow1)}
            style={{
              width: `calc(${sizeQR}rem + 0.5rem)`,
              height: `calc(${sizeQR}rem + 1rem)`,
              padding: `0.5rem`,
            }}
          >
            <div
              style={{
                padding: `${paddingQR}rem`,
                width: `${sizeQR}rem`,
                height: `${sizeQR}rem`,
              }}
            >
              <img src={qrCode1} alt="" />
            </div>
          </motion.div>
        )}
        {qrCode2 && (
          <motion.div
            key={currentState + 'qr2'}
            className={classNames(styles.rainbow, styles.rainbow2)}
            style={{
              width: `calc(${sizeQR}rem + 0.5rem)`,
              height: `calc(${sizeQR}rem + 1rem)`,
              padding: `0.5rem`,
            }}
          >
            <div
              style={{
                padding: `${paddingQR}rem`,
                width: `${sizeQR}rem`,
                height: `${sizeQR}rem`,
              }}
            >
              <img src={qrCode2} alt="" />
            </div>
          </motion.div>
        )}
      </div>
    </motion.div>
  )
})

export default AdvtFullSize
